module.exports = __webpack_public_path__ + "img/2000_5cda4bbb13152.8aa2e853.jpg";